import React from "react";
import styled from "styled-components";

const OnBoradingSubHeader = ({ header, color }) => {
  return <StyledHeader color={color}>{header}</StyledHeader>;
};

const StyledHeader = styled.text`
  font-weight: 500;
  font-size: 1.375rem;
  color: ${(props) => props.color};
  text-align: center;
  max-width: 25rem;
  @media only screen and (max-width: 478px) {
    font-size: 1.2rem;
  }
`;

export default OnBoradingSubHeader;
